const CDN_ROOT = `https://${process.env.NEXT_PUBLIC_CDN_HOST}/`;

export const assets = {
    flagDir: CDN_ROOT + 'file-asset/file/41d1c51267e75b39c055ec32675ee246/1748424386682/',
    sns: {
        facebook: 'file-asset/file/42de23524d51930efe393c04ff1bf321.svg',
        x: 'asset/width-126/picture/6a3ebbd61918561d772d5771ee948013.png',
        whatsApp: 'asset/width-126/picture/01b1118802bf27b3d723fc74e71bfbe1.png'
    },
}